import { render, staticRenderFns } from "./SendMailToAdmin.vue?vue&type=template&id=11ebe8bb&"
import script from "./SendMailToAdmin.vue?vue&type=script&lang=js&"
export * from "./SendMailToAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SendMailToAdmin.vue?vue&type=style&index=0&id=11ebe8bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports